import { j as Wt } from "../../../jsx-runtime-BwWtxLpl.js";
import et, { useState as Ce, useMemo as ht, useRef as ce, useEffect as J, useCallback as le } from "react";
import A from "prop-types";
import yt from "react-dom";
import kt from "../placementOptions.js";
function Ht(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function L() {
  return L = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, L.apply(this, arguments);
}
function bt(e, t) {
  if (e == null)
    return {};
  var r = {}, n = Object.keys(e), o, i;
  for (i = 0; i < n.length; i++)
    o = n[i], !(t.indexOf(o) >= 0) && (r[o] = e[o]);
  return r;
}
function tt() {
  return Ce(null);
}
const rt = (e) => !e || typeof e == "function" ? e : (t) => {
  e.current = t;
};
function Vt(e, t) {
  const r = rt(e), n = rt(t);
  return (o) => {
    r && r(o), n && n(o);
  };
}
function Ft(e, t) {
  return ht(() => Vt(e, t), [e, t]);
}
var S = "top", k = "bottom", H = "right", T = "left", We = "auto", ve = [S, k, H, T], ee = "start", pe = "end", _t = "clippingParents", wt = "viewport", se = "popper", Nt = "reference", nt = /* @__PURE__ */ ve.reduce(function(e, t) {
  return e.concat([t + "-" + ee, t + "-" + pe]);
}, []), ke = /* @__PURE__ */ [].concat(ve, [We]).reduce(function(e, t) {
  return e.concat([t, t + "-" + ee, t + "-" + pe]);
}, []), It = "beforeRead", qt = "read", Ut = "afterRead", Xt = "beforeMain", Yt = "main", Kt = "afterMain", zt = "beforeWrite", Gt = "write", Jt = "afterWrite", Qt = [It, qt, Ut, Xt, Yt, Kt, zt, Gt, Jt];
function V(e) {
  return e.split("-")[0];
}
function W(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function Q(e) {
  var t = W(e).Element;
  return e instanceof t || e instanceof Element;
}
function F(e) {
  var t = W(e).HTMLElement;
  return e instanceof t || e instanceof HTMLElement;
}
function He(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var t = W(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}
var G = Math.max, Ee = Math.min, te = Math.round;
function Le() {
  var e = navigator.userAgentData;
  return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(t) {
    return t.brand + "/" + t.version;
  }).join(" ") : navigator.userAgent;
}
function xt() {
  return !/^((?!chrome|android).)*safari/i.test(Le());
}
function re(e, t, r) {
  t === void 0 && (t = !1), r === void 0 && (r = !1);
  var n = e.getBoundingClientRect(), o = 1, i = 1;
  t && F(e) && (o = e.offsetWidth > 0 && te(n.width) / e.offsetWidth || 1, i = e.offsetHeight > 0 && te(n.height) / e.offsetHeight || 1);
  var f = Q(e) ? W(e) : window, a = f.visualViewport, s = !xt() && r, l = (n.left + (s && a ? a.offsetLeft : 0)) / o, u = (n.top + (s && a ? a.offsetTop : 0)) / i, m = n.width / o, p = n.height / i;
  return {
    width: m,
    height: p,
    top: u,
    right: l + m,
    bottom: u + p,
    left: l,
    x: l,
    y: u
  };
}
function Ve(e) {
  var t = re(e), r = e.offsetWidth, n = e.offsetHeight;
  return Math.abs(t.width - r) <= 1 && (r = t.width), Math.abs(t.height - n) <= 1 && (n = t.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: r,
    height: n
  };
}
function Ot(e, t) {
  var r = t.getRootNode && t.getRootNode();
  if (e.contains(t))
    return !0;
  if (r && He(r)) {
    var n = t;
    do {
      if (n && e.isSameNode(n))
        return !0;
      n = n.parentNode || n.host;
    } while (n);
  }
  return !1;
}
function U(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function I(e) {
  return W(e).getComputedStyle(e);
}
function Zt(e) {
  return ["table", "td", "th"].indexOf(U(e)) >= 0;
}
function X(e) {
  return ((Q(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function Ae(e) {
  return U(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (He(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    X(e)
  );
}
function ot(e) {
  return !F(e) || // https://github.com/popperjs/popper-core/issues/837
  I(e).position === "fixed" ? null : e.offsetParent;
}
function er(e) {
  var t = /firefox/i.test(Le()), r = /Trident/i.test(Le());
  if (r && F(e)) {
    var n = I(e);
    if (n.position === "fixed")
      return null;
  }
  var o = Ae(e);
  for (He(o) && (o = o.host); F(o) && ["html", "body"].indexOf(U(o)) < 0; ) {
    var i = I(o);
    if (i.transform !== "none" || i.perspective !== "none" || i.contain === "paint" || ["transform", "perspective"].indexOf(i.willChange) !== -1 || t && i.willChange === "filter" || t && i.filter && i.filter !== "none")
      return o;
    o = o.parentNode;
  }
  return null;
}
function me(e) {
  for (var t = W(e), r = ot(e); r && Zt(r) && I(r).position === "static"; )
    r = ot(r);
  return r && (U(r) === "html" || U(r) === "body" && I(r).position === "static") ? t : r || er(e) || t;
}
function Fe(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function fe(e, t, r) {
  return G(e, Ee(t, r));
}
function tr(e, t, r) {
  var n = fe(e, t, r);
  return n > r ? r : n;
}
function Et() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function Ct(e) {
  return Object.assign({}, Et(), e);
}
function At(e, t) {
  return t.reduce(function(r, n) {
    return r[n] = e, r;
  }, {});
}
var rr = function(t, r) {
  return t = typeof t == "function" ? t(Object.assign({}, r.rects, {
    placement: r.placement
  })) : t, Ct(typeof t != "number" ? t : At(t, ve));
};
function nr(e) {
  var t, r = e.state, n = e.name, o = e.options, i = r.elements.arrow, f = r.modifiersData.popperOffsets, a = V(r.placement), s = Fe(a), l = [T, H].indexOf(a) >= 0, u = l ? "height" : "width";
  if (!(!i || !f)) {
    var m = rr(o.padding, r), p = Ve(i), c = s === "y" ? S : T, g = s === "y" ? k : H, v = r.rects.reference[u] + r.rects.reference[s] - f[s] - r.rects.popper[u], h = f[s] - r.rects.reference[s], x = me(i), b = x ? s === "y" ? x.clientHeight || 0 : x.clientWidth || 0 : 0, O = v / 2 - h / 2, d = m[c], w = b - p[u] - m[g], y = b / 2 - p[u] / 2 + O, E = fe(d, y, w), R = s;
    r.modifiersData[n] = (t = {}, t[R] = E, t.centerOffset = E - y, t);
  }
}
function or(e) {
  var t = e.state, r = e.options, n = r.element, o = n === void 0 ? "[data-popper-arrow]" : n;
  o != null && (typeof o == "string" && (o = t.elements.popper.querySelector(o), !o) || Ot(t.elements.popper, o) && (t.elements.arrow = o));
}
const ir = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: nr,
  effect: or,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function ne(e) {
  return e.split("-")[1];
}
var ar = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function sr(e, t) {
  var r = e.x, n = e.y, o = t.devicePixelRatio || 1;
  return {
    x: te(r * o) / o || 0,
    y: te(n * o) / o || 0
  };
}
function it(e) {
  var t, r = e.popper, n = e.popperRect, o = e.placement, i = e.variation, f = e.offsets, a = e.position, s = e.gpuAcceleration, l = e.adaptive, u = e.roundOffsets, m = e.isFixed, p = f.x, c = p === void 0 ? 0 : p, g = f.y, v = g === void 0 ? 0 : g, h = typeof u == "function" ? u({
    x: c,
    y: v
  }) : {
    x: c,
    y: v
  };
  c = h.x, v = h.y;
  var x = f.hasOwnProperty("x"), b = f.hasOwnProperty("y"), O = T, d = S, w = window;
  if (l) {
    var y = me(r), E = "clientHeight", R = "clientWidth";
    if (y === W(r) && (y = X(r), I(y).position !== "static" && a === "absolute" && (E = "scrollHeight", R = "scrollWidth")), y = y, o === S || (o === T || o === H) && i === pe) {
      d = k;
      var C = m && y === w && w.visualViewport ? w.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        y[E]
      );
      v -= C - n.height, v *= s ? 1 : -1;
    }
    if (o === T || (o === S || o === k) && i === pe) {
      O = H;
      var P = m && y === w && w.visualViewport ? w.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        y[R]
      );
      c -= P - n.width, c *= s ? 1 : -1;
    }
  }
  var D = Object.assign({
    position: a
  }, l && ar), M = u === !0 ? sr({
    x: c,
    y: v
  }, W(r)) : {
    x: c,
    y: v
  };
  if (c = M.x, v = M.y, s) {
    var $;
    return Object.assign({}, D, ($ = {}, $[d] = b ? "0" : "", $[O] = x ? "0" : "", $.transform = (w.devicePixelRatio || 1) <= 1 ? "translate(" + c + "px, " + v + "px)" : "translate3d(" + c + "px, " + v + "px, 0)", $));
  }
  return Object.assign({}, D, (t = {}, t[d] = b ? v + "px" : "", t[O] = x ? c + "px" : "", t.transform = "", t));
}
function fr(e) {
  var t = e.state, r = e.options, n = r.gpuAcceleration, o = n === void 0 ? !0 : n, i = r.adaptive, f = i === void 0 ? !0 : i, a = r.roundOffsets, s = a === void 0 ? !0 : a, l = {
    placement: V(t.placement),
    variation: ne(t.placement),
    popper: t.elements.popper,
    popperRect: t.rects.popper,
    gpuAcceleration: o,
    isFixed: t.options.strategy === "fixed"
  };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, it(Object.assign({}, l, {
    offsets: t.modifiersData.popperOffsets,
    position: t.options.strategy,
    adaptive: f,
    roundOffsets: s
  })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, it(Object.assign({}, l, {
    offsets: t.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: s
  })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-placement": t.placement
  });
}
const ur = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: fr,
  data: {}
};
var we = {
  passive: !0
};
function cr(e) {
  var t = e.state, r = e.instance, n = e.options, o = n.scroll, i = o === void 0 ? !0 : o, f = n.resize, a = f === void 0 ? !0 : f, s = W(t.elements.popper), l = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return i && l.forEach(function(u) {
    u.addEventListener("scroll", r.update, we);
  }), a && s.addEventListener("resize", r.update, we), function() {
    i && l.forEach(function(u) {
      u.removeEventListener("scroll", r.update, we);
    }), a && s.removeEventListener("resize", r.update, we);
  };
}
const lr = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: cr,
  data: {}
};
var pr = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function Oe(e) {
  return e.replace(/left|right|bottom|top/g, function(t) {
    return pr[t];
  });
}
var dr = {
  start: "end",
  end: "start"
};
function at(e) {
  return e.replace(/start|end/g, function(t) {
    return dr[t];
  });
}
function _e(e) {
  var t = W(e), r = t.pageXOffset, n = t.pageYOffset;
  return {
    scrollLeft: r,
    scrollTop: n
  };
}
function Ne(e) {
  return re(X(e)).left + _e(e).scrollLeft;
}
function vr(e, t) {
  var r = W(e), n = X(e), o = r.visualViewport, i = n.clientWidth, f = n.clientHeight, a = 0, s = 0;
  if (o) {
    i = o.width, f = o.height;
    var l = xt();
    (l || !l && t === "fixed") && (a = o.offsetLeft, s = o.offsetTop);
  }
  return {
    width: i,
    height: f,
    x: a + Ne(e),
    y: s
  };
}
function mr(e) {
  var t, r = X(e), n = _e(e), o = (t = e.ownerDocument) == null ? void 0 : t.body, i = G(r.scrollWidth, r.clientWidth, o ? o.scrollWidth : 0, o ? o.clientWidth : 0), f = G(r.scrollHeight, r.clientHeight, o ? o.scrollHeight : 0, o ? o.clientHeight : 0), a = -n.scrollLeft + Ne(e), s = -n.scrollTop;
  return I(o || r).direction === "rtl" && (a += G(r.clientWidth, o ? o.clientWidth : 0) - i), {
    width: i,
    height: f,
    x: a,
    y: s
  };
}
function Ie(e) {
  var t = I(e), r = t.overflow, n = t.overflowX, o = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(r + o + n);
}
function Rt(e) {
  return ["html", "body", "#document"].indexOf(U(e)) >= 0 ? e.ownerDocument.body : F(e) && Ie(e) ? e : Rt(Ae(e));
}
function ue(e, t) {
  var r;
  t === void 0 && (t = []);
  var n = Rt(e), o = n === ((r = e.ownerDocument) == null ? void 0 : r.body), i = W(n), f = o ? [i].concat(i.visualViewport || [], Ie(n) ? n : []) : n, a = t.concat(f);
  return o ? a : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    a.concat(ue(Ae(f)))
  );
}
function Se(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function gr(e, t) {
  var r = re(e, !1, t === "fixed");
  return r.top = r.top + e.clientTop, r.left = r.left + e.clientLeft, r.bottom = r.top + e.clientHeight, r.right = r.left + e.clientWidth, r.width = e.clientWidth, r.height = e.clientHeight, r.x = r.left, r.y = r.top, r;
}
function st(e, t, r) {
  return t === wt ? Se(vr(e, r)) : Q(t) ? gr(t, r) : Se(mr(X(e)));
}
function hr(e) {
  var t = ue(Ae(e)), r = ["absolute", "fixed"].indexOf(I(e).position) >= 0, n = r && F(e) ? me(e) : e;
  return Q(n) ? t.filter(function(o) {
    return Q(o) && Ot(o, n) && U(o) !== "body";
  }) : [];
}
function yr(e, t, r, n) {
  var o = t === "clippingParents" ? hr(e) : [].concat(t), i = [].concat(o, [r]), f = i[0], a = i.reduce(function(s, l) {
    var u = st(e, l, n);
    return s.top = G(u.top, s.top), s.right = Ee(u.right, s.right), s.bottom = Ee(u.bottom, s.bottom), s.left = G(u.left, s.left), s;
  }, st(e, f, n));
  return a.width = a.right - a.left, a.height = a.bottom - a.top, a.x = a.left, a.y = a.top, a;
}
function Pt(e) {
  var t = e.reference, r = e.element, n = e.placement, o = n ? V(n) : null, i = n ? ne(n) : null, f = t.x + t.width / 2 - r.width / 2, a = t.y + t.height / 2 - r.height / 2, s;
  switch (o) {
    case S:
      s = {
        x: f,
        y: t.y - r.height
      };
      break;
    case k:
      s = {
        x: f,
        y: t.y + t.height
      };
      break;
    case H:
      s = {
        x: t.x + t.width,
        y: a
      };
      break;
    case T:
      s = {
        x: t.x - r.width,
        y: a
      };
      break;
    default:
      s = {
        x: t.x,
        y: t.y
      };
  }
  var l = o ? Fe(o) : null;
  if (l != null) {
    var u = l === "y" ? "height" : "width";
    switch (i) {
      case ee:
        s[l] = s[l] - (t[u] / 2 - r[u] / 2);
        break;
      case pe:
        s[l] = s[l] + (t[u] / 2 - r[u] / 2);
        break;
    }
  }
  return s;
}
function de(e, t) {
  t === void 0 && (t = {});
  var r = t, n = r.placement, o = n === void 0 ? e.placement : n, i = r.strategy, f = i === void 0 ? e.strategy : i, a = r.boundary, s = a === void 0 ? _t : a, l = r.rootBoundary, u = l === void 0 ? wt : l, m = r.elementContext, p = m === void 0 ? se : m, c = r.altBoundary, g = c === void 0 ? !1 : c, v = r.padding, h = v === void 0 ? 0 : v, x = Ct(typeof h != "number" ? h : At(h, ve)), b = p === se ? Nt : se, O = e.rects.popper, d = e.elements[g ? b : p], w = yr(Q(d) ? d : d.contextElement || X(e.elements.popper), s, u, f), y = re(e.elements.reference), E = Pt({
    reference: y,
    element: O,
    strategy: "absolute",
    placement: o
  }), R = Se(Object.assign({}, O, E)), C = p === se ? R : y, P = {
    top: w.top - C.top + x.top,
    bottom: C.bottom - w.bottom + x.bottom,
    left: w.left - C.left + x.left,
    right: C.right - w.right + x.right
  }, D = e.modifiersData.offset;
  if (p === se && D) {
    var M = D[o];
    Object.keys(P).forEach(function($) {
      var _ = [H, k].indexOf($) >= 0 ? 1 : -1, N = [S, k].indexOf($) >= 0 ? "y" : "x";
      P[$] += M[N] * _;
    });
  }
  return P;
}
function br(e, t) {
  t === void 0 && (t = {});
  var r = t, n = r.placement, o = r.boundary, i = r.rootBoundary, f = r.padding, a = r.flipVariations, s = r.allowedAutoPlacements, l = s === void 0 ? ke : s, u = ne(n), m = u ? a ? nt : nt.filter(function(g) {
    return ne(g) === u;
  }) : ve, p = m.filter(function(g) {
    return l.indexOf(g) >= 0;
  });
  p.length === 0 && (p = m);
  var c = p.reduce(function(g, v) {
    return g[v] = de(e, {
      placement: v,
      boundary: o,
      rootBoundary: i,
      padding: f
    })[V(v)], g;
  }, {});
  return Object.keys(c).sort(function(g, v) {
    return c[g] - c[v];
  });
}
function wr(e) {
  if (V(e) === We)
    return [];
  var t = Oe(e);
  return [at(e), t, at(t)];
}
function xr(e) {
  var t = e.state, r = e.options, n = e.name;
  if (!t.modifiersData[n]._skip) {
    for (var o = r.mainAxis, i = o === void 0 ? !0 : o, f = r.altAxis, a = f === void 0 ? !0 : f, s = r.fallbackPlacements, l = r.padding, u = r.boundary, m = r.rootBoundary, p = r.altBoundary, c = r.flipVariations, g = c === void 0 ? !0 : c, v = r.allowedAutoPlacements, h = t.options.placement, x = V(h), b = x === h, O = s || (b || !g ? [Oe(h)] : wr(h)), d = [h].concat(O).reduce(function(Z, q) {
      return Z.concat(V(q) === We ? br(t, {
        placement: q,
        boundary: u,
        rootBoundary: m,
        padding: l,
        flipVariations: g,
        allowedAutoPlacements: v
      }) : q);
    }, []), w = t.rects.reference, y = t.rects.popper, E = /* @__PURE__ */ new Map(), R = !0, C = d[0], P = 0; P < d.length; P++) {
      var D = d[P], M = V(D), $ = ne(D) === ee, _ = [S, k].indexOf(M) >= 0, N = _ ? "width" : "height", j = de(t, {
        placement: D,
        boundary: u,
        rootBoundary: m,
        altBoundary: p,
        padding: l
      }), B = _ ? $ ? H : T : $ ? k : S;
      w[N] > y[N] && (B = Oe(B));
      var oe = Oe(B), Y = [];
      if (i && Y.push(j[M] <= 0), a && Y.push(j[B] <= 0, j[oe] <= 0), Y.every(function(Z) {
        return Z;
      })) {
        C = D, R = !1;
        break;
      }
      E.set(D, Y);
    }
    if (R)
      for (var ge = g ? 3 : 1, Re = function(q) {
        var ae = d.find(function(ye) {
          var K = E.get(ye);
          if (K)
            return K.slice(0, q).every(function(Pe) {
              return Pe;
            });
        });
        if (ae)
          return C = ae, "break";
      }, ie = ge; ie > 0; ie--) {
        var he = Re(ie);
        if (he === "break")
          break;
      }
    t.placement !== C && (t.modifiersData[n]._skip = !0, t.placement = C, t.reset = !0);
  }
}
const Or = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: xr,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function ft(e, t, r) {
  return r === void 0 && (r = {
    x: 0,
    y: 0
  }), {
    top: e.top - t.height - r.y,
    right: e.right - t.width + r.x,
    bottom: e.bottom - t.height + r.y,
    left: e.left - t.width - r.x
  };
}
function ut(e) {
  return [S, H, k, T].some(function(t) {
    return e[t] >= 0;
  });
}
function Er(e) {
  var t = e.state, r = e.name, n = t.rects.reference, o = t.rects.popper, i = t.modifiersData.preventOverflow, f = de(t, {
    elementContext: "reference"
  }), a = de(t, {
    altBoundary: !0
  }), s = ft(f, n), l = ft(a, o, i), u = ut(s), m = ut(l);
  t.modifiersData[r] = {
    referenceClippingOffsets: s,
    popperEscapeOffsets: l,
    isReferenceHidden: u,
    hasPopperEscaped: m
  }, t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-reference-hidden": u,
    "data-popper-escaped": m
  });
}
const Cr = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: Er
};
function Ar(e, t, r) {
  var n = V(e), o = [T, S].indexOf(n) >= 0 ? -1 : 1, i = typeof r == "function" ? r(Object.assign({}, t, {
    placement: e
  })) : r, f = i[0], a = i[1];
  return f = f || 0, a = (a || 0) * o, [T, H].indexOf(n) >= 0 ? {
    x: a,
    y: f
  } : {
    x: f,
    y: a
  };
}
function Rr(e) {
  var t = e.state, r = e.options, n = e.name, o = r.offset, i = o === void 0 ? [0, 0] : o, f = ke.reduce(function(u, m) {
    return u[m] = Ar(m, t.rects, i), u;
  }, {}), a = f[t.placement], s = a.x, l = a.y;
  t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += s, t.modifiersData.popperOffsets.y += l), t.modifiersData[n] = f;
}
const Pr = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: Rr
};
function Dr(e) {
  var t = e.state, r = e.name;
  t.modifiersData[r] = Pt({
    reference: t.rects.reference,
    element: t.rects.popper,
    strategy: "absolute",
    placement: t.placement
  });
}
const $r = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: Dr,
  data: {}
};
function Mr(e) {
  return e === "x" ? "y" : "x";
}
function jr(e) {
  var t = e.state, r = e.options, n = e.name, o = r.mainAxis, i = o === void 0 ? !0 : o, f = r.altAxis, a = f === void 0 ? !1 : f, s = r.boundary, l = r.rootBoundary, u = r.altBoundary, m = r.padding, p = r.tether, c = p === void 0 ? !0 : p, g = r.tetherOffset, v = g === void 0 ? 0 : g, h = de(t, {
    boundary: s,
    rootBoundary: l,
    padding: m,
    altBoundary: u
  }), x = V(t.placement), b = ne(t.placement), O = !b, d = Fe(x), w = Mr(d), y = t.modifiersData.popperOffsets, E = t.rects.reference, R = t.rects.popper, C = typeof v == "function" ? v(Object.assign({}, t.rects, {
    placement: t.placement
  })) : v, P = typeof C == "number" ? {
    mainAxis: C,
    altAxis: C
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, C), D = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, M = {
    x: 0,
    y: 0
  };
  if (y) {
    if (i) {
      var $, _ = d === "y" ? S : T, N = d === "y" ? k : H, j = d === "y" ? "height" : "width", B = y[d], oe = B + h[_], Y = B - h[N], ge = c ? -R[j] / 2 : 0, Re = b === ee ? E[j] : R[j], ie = b === ee ? -R[j] : -E[j], he = t.elements.arrow, Z = c && he ? Ve(he) : {
        width: 0,
        height: 0
      }, q = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : Et(), ae = q[_], ye = q[N], K = fe(0, E[j], Z[j]), Pe = O ? E[j] / 2 - ge - K - ae - P.mainAxis : Re - K - ae - P.mainAxis, Mt = O ? -E[j] / 2 + ge + K + ye + P.mainAxis : ie + K + ye + P.mainAxis, De = t.elements.arrow && me(t.elements.arrow), jt = De ? d === "y" ? De.clientTop || 0 : De.clientLeft || 0 : 0, Ue = ($ = D == null ? void 0 : D[d]) != null ? $ : 0, Lt = B + Pe - Ue - jt, St = B + Mt - Ue, Xe = fe(c ? Ee(oe, Lt) : oe, B, c ? G(Y, St) : Y);
      y[d] = Xe, M[d] = Xe - B;
    }
    if (a) {
      var Ye, Tt = d === "x" ? S : T, Bt = d === "x" ? k : H, z = y[w], be = w === "y" ? "height" : "width", Ke = z + h[Tt], ze = z - h[Bt], $e = [S, T].indexOf(x) !== -1, Ge = (Ye = D == null ? void 0 : D[w]) != null ? Ye : 0, Je = $e ? Ke : z - E[be] - R[be] - Ge + P.altAxis, Qe = $e ? z + E[be] + R[be] - Ge - P.altAxis : ze, Ze = c && $e ? tr(Je, z, Qe) : fe(c ? Je : Ke, z, c ? Qe : ze);
      y[w] = Ze, M[w] = Ze - z;
    }
    t.modifiersData[n] = M;
  }
}
const Lr = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: jr,
  requiresIfExists: ["offset"]
};
function Sr(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function Tr(e) {
  return e === W(e) || !F(e) ? _e(e) : Sr(e);
}
function Br(e) {
  var t = e.getBoundingClientRect(), r = te(t.width) / e.offsetWidth || 1, n = te(t.height) / e.offsetHeight || 1;
  return r !== 1 || n !== 1;
}
function Wr(e, t, r) {
  r === void 0 && (r = !1);
  var n = F(t), o = F(t) && Br(t), i = X(t), f = re(e, o, r), a = {
    scrollLeft: 0,
    scrollTop: 0
  }, s = {
    x: 0,
    y: 0
  };
  return (n || !n && !r) && ((U(t) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  Ie(i)) && (a = Tr(t)), F(t) ? (s = re(t, !0), s.x += t.clientLeft, s.y += t.clientTop) : i && (s.x = Ne(i))), {
    x: f.left + a.scrollLeft - s.x,
    y: f.top + a.scrollTop - s.y,
    width: f.width,
    height: f.height
  };
}
function kr(e) {
  var t = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Set(), n = [];
  e.forEach(function(i) {
    t.set(i.name, i);
  });
  function o(i) {
    r.add(i.name);
    var f = [].concat(i.requires || [], i.requiresIfExists || []);
    f.forEach(function(a) {
      if (!r.has(a)) {
        var s = t.get(a);
        s && o(s);
      }
    }), n.push(i);
  }
  return e.forEach(function(i) {
    r.has(i.name) || o(i);
  }), n;
}
function Hr(e) {
  var t = kr(e);
  return Qt.reduce(function(r, n) {
    return r.concat(t.filter(function(o) {
      return o.phase === n;
    }));
  }, []);
}
function Vr(e) {
  var t;
  return function() {
    return t || (t = new Promise(function(r) {
      Promise.resolve().then(function() {
        t = void 0, r(e());
      });
    })), t;
  };
}
function Fr(e) {
  var t = e.reduce(function(r, n) {
    var o = r[n.name];
    return r[n.name] = o ? Object.assign({}, o, n, {
      options: Object.assign({}, o.options, n.options),
      data: Object.assign({}, o.data, n.data)
    }) : n, r;
  }, {});
  return Object.keys(t).map(function(r) {
    return t[r];
  });
}
var ct = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function lt() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  return !t.some(function(n) {
    return !(n && typeof n.getBoundingClientRect == "function");
  });
}
function _r(e) {
  e === void 0 && (e = {});
  var t = e, r = t.defaultModifiers, n = r === void 0 ? [] : r, o = t.defaultOptions, i = o === void 0 ? ct : o;
  return function(a, s, l) {
    l === void 0 && (l = i);
    var u = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, ct, i),
      modifiersData: {},
      elements: {
        reference: a,
        popper: s
      },
      attributes: {},
      styles: {}
    }, m = [], p = !1, c = {
      state: u,
      setOptions: function(x) {
        var b = typeof x == "function" ? x(u.options) : x;
        v(), u.options = Object.assign({}, i, u.options, b), u.scrollParents = {
          reference: Q(a) ? ue(a) : a.contextElement ? ue(a.contextElement) : [],
          popper: ue(s)
        };
        var O = Hr(Fr([].concat(n, u.options.modifiers)));
        return u.orderedModifiers = O.filter(function(d) {
          return d.enabled;
        }), g(), c.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!p) {
          var x = u.elements, b = x.reference, O = x.popper;
          if (lt(b, O)) {
            u.rects = {
              reference: Wr(b, me(O), u.options.strategy === "fixed"),
              popper: Ve(O)
            }, u.reset = !1, u.placement = u.options.placement, u.orderedModifiers.forEach(function(P) {
              return u.modifiersData[P.name] = Object.assign({}, P.data);
            });
            for (var d = 0; d < u.orderedModifiers.length; d++) {
              if (u.reset === !0) {
                u.reset = !1, d = -1;
                continue;
              }
              var w = u.orderedModifiers[d], y = w.fn, E = w.options, R = E === void 0 ? {} : E, C = w.name;
              typeof y == "function" && (u = y({
                state: u,
                options: R,
                name: C,
                instance: c
              }) || u);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: Vr(function() {
        return new Promise(function(h) {
          c.forceUpdate(), h(u);
        });
      }),
      destroy: function() {
        v(), p = !0;
      }
    };
    if (!lt(a, s))
      return c;
    c.setOptions(l).then(function(h) {
      !p && l.onFirstUpdate && l.onFirstUpdate(h);
    });
    function g() {
      u.orderedModifiers.forEach(function(h) {
        var x = h.name, b = h.options, O = b === void 0 ? {} : b, d = h.effect;
        if (typeof d == "function") {
          var w = d({
            state: u,
            name: x,
            instance: c,
            options: O
          }), y = function() {
          };
          m.push(w || y);
        }
      });
    }
    function v() {
      m.forEach(function(h) {
        return h();
      }), m = [];
    }
    return c;
  };
}
var Nr = _r({
  defaultModifiers: [Cr, $r, ur, lr, Pr, Or, Lr, ir]
});
function Ir() {
  const e = ce(!0), t = ce(() => e.current);
  return J(() => (e.current = !0, () => {
    e.current = !1;
  }), []), t.current;
}
function qr(e) {
  const t = Ir();
  return [e[0], le((r) => {
    if (t())
      return e[1](r);
  }, [t, e[1]])];
}
var pt = function(t) {
  return {
    position: t,
    top: "0",
    left: "0",
    opacity: "0",
    pointerEvents: "none"
  };
}, Ur = {
  name: "applyStyles",
  enabled: !1
}, Xr = {
  name: "ariaDescribedBy",
  enabled: !0,
  phase: "afterWrite",
  effect: function(t) {
    var r = t.state;
    return function() {
      var n = r.elements, o = n.reference, i = n.popper;
      if ("removeAttribute" in o) {
        var f = (o.getAttribute("aria-describedby") || "").split(",").filter(function(a) {
          return a.trim() !== i.id;
        });
        f.length ? o.setAttribute("aria-describedby", f.join(",")) : o.removeAttribute("aria-describedby");
      }
    };
  },
  fn: function(t) {
    var r, n = t.state, o = n.elements, i = o.popper, f = o.reference, a = (r = i.getAttribute("role")) == null ? void 0 : r.toLowerCase();
    if (i.id && a === "tooltip" && "setAttribute" in f) {
      var s = f.getAttribute("aria-describedby");
      if (s && s.split(",").indexOf(i.id) !== -1)
        return;
      f.setAttribute("aria-describedby", s ? s + "," + i.id : i.id);
    }
  }
}, Yr = [];
function Kr(e, t, r) {
  var n = r === void 0 ? {} : r, o = n.enabled, i = o === void 0 ? !0 : o, f = n.placement, a = f === void 0 ? "bottom" : f, s = n.strategy, l = s === void 0 ? "absolute" : s, u = n.modifiers, m = u === void 0 ? Yr : u, p = bt(n, ["enabled", "placement", "strategy", "modifiers"]), c = ce(), g = le(function() {
    var d;
    (d = c.current) == null || d.update();
  }, []), v = le(function() {
    var d;
    (d = c.current) == null || d.forceUpdate();
  }, []), h = qr(Ce({
    placement: a,
    update: g,
    forceUpdate: v,
    attributes: {},
    styles: {
      popper: pt(l),
      arrow: {}
    }
  })), x = h[0], b = h[1], O = ht(function() {
    return {
      name: "updateStateModifier",
      enabled: !0,
      phase: "write",
      requires: ["computeStyles"],
      fn: function(w) {
        var y = w.state, E = {}, R = {};
        Object.keys(y.elements).forEach(function(C) {
          E[C] = y.styles[C], R[C] = y.attributes[C];
        }), b({
          state: y,
          styles: E,
          attributes: R,
          update: g,
          forceUpdate: v,
          placement: y.placement
        });
      }
    };
  }, [g, v, b]);
  return J(function() {
    !c.current || !i || c.current.setOptions({
      placement: a,
      strategy: l,
      modifiers: [].concat(m, [O, Ur])
    });
  }, [l, a, O, i]), J(function() {
    if (!(!i || e == null || t == null))
      return c.current = Nr(e, t, L({}, p, {
        placement: a,
        strategy: l,
        modifiers: [].concat(m, [Xr, O])
      })), function() {
        c.current != null && (c.current.destroy(), c.current = void 0, b(function(d) {
          return L({}, d, {
            attributes: {},
            styles: {
              popper: pt(l)
            }
          });
        }));
      };
  }, [i, e, t]), x;
}
function zr(e, t) {
  if (e.contains)
    return e.contains(t);
  if (e.compareDocumentPosition)
    return e === t || !!(e.compareDocumentPosition(t) & 16);
}
const Gr = !!(typeof window < "u" && window.document && window.document.createElement);
var Te = !1, Be = !1;
try {
  var Me = {
    get passive() {
      return Te = !0;
    },
    get once() {
      return Be = Te = !0;
    }
  };
  Gr && (window.addEventListener("test", Me, Me), window.removeEventListener("test", Me, !0));
} catch {
}
function Jr(e, t, r, n) {
  if (n && typeof n != "boolean" && !Be) {
    var o = n.once, i = n.capture, f = r;
    !Be && o && (f = r.__once || function a(s) {
      this.removeEventListener(t, a, i), r.call(this, s);
    }, r.__once = f), e.addEventListener(t, f, Te ? n : i);
  }
  e.addEventListener(t, r, n);
}
function Qr(e, t, r, n) {
  var o = n && typeof n != "boolean" ? n.capture : n;
  e.removeEventListener(t, r, o), r.__once && e.removeEventListener(t, r.__once, o);
}
function xe(e, t, r, n) {
  return Jr(e, t, r, n), function() {
    Qr(e, t, r, n);
  };
}
function Zr(e) {
  const t = ce(e);
  return J(() => {
    t.current = e;
  }, [e]), t;
}
function dt(e) {
  const t = Zr(e);
  return le(function(...r) {
    return t.current && t.current(...r);
  }, [t]);
}
var en = process.env.NODE_ENV !== "production", Dt = function() {
};
if (en) {
  var tn = function(t, r) {
    var n = arguments.length;
    r = new Array(n > 1 ? n - 1 : 0);
    for (var o = 1; o < n; o++)
      r[o - 1] = arguments[o];
    var i = 0, f = "Warning: " + t.replace(/%s/g, function() {
      return r[i++];
    });
    typeof console < "u" && console.error(f);
    try {
      throw new Error(f);
    } catch {
    }
  };
  Dt = function(e, t, r) {
    var n = arguments.length;
    r = new Array(n > 2 ? n - 2 : 0);
    for (var o = 2; o < n; o++)
      r[o - 2] = arguments[o];
    if (t === void 0)
      throw new Error(
        "`warning(condition, format, ...args)` requires a warning message argument"
      );
    e || tn.apply(null, [t].concat(r));
  };
}
var rn = Dt;
const nn = /* @__PURE__ */ Ht(rn);
function $t(e) {
  return e && e.ownerDocument || document;
}
function on(e) {
  return e && "setState" in e ? yt.findDOMNode(e) : e ?? null;
}
const an = function(e) {
  return $t(on(e));
};
var sn = 27, vt = function() {
};
function fn(e) {
  return e.button === 0;
}
function un(e) {
  return !!(e.metaKey || e.altKey || e.ctrlKey || e.shiftKey);
}
var mt = function(t) {
  return t && ("current" in t ? t.current : t);
};
function cn(e, t, r) {
  var n = r === void 0 ? {} : r, o = n.disabled, i = n.clickTrigger, f = i === void 0 ? "click" : i, a = ce(!1), s = t || vt, l = le(function(p) {
    var c, g = mt(e);
    nn(!!g, "RootClose captured a close event but does not have a ref to compare it to. useRootClose(), should be passed a ref that resolves to a DOM node"), a.current = !g || un(p) || !fn(p) || !!zr(g, (c = p.composedPath == null ? void 0 : p.composedPath()[0]) != null ? c : p.target);
  }, [e]), u = dt(function(p) {
    a.current || s(p);
  }), m = dt(function(p) {
    p.keyCode === sn && s(p);
  });
  J(function() {
    if (!(o || e == null)) {
      var p = window.event, c = an(mt(e)), g = xe(c, f, l, !0), v = xe(c, f, function(b) {
        if (b === p) {
          p = void 0;
          return;
        }
        u(b);
      }), h = xe(c, "keyup", function(b) {
        if (b === p) {
          p = void 0;
          return;
        }
        m(b);
      }), x = [];
      return "ontouchstart" in c.documentElement && (x = [].slice.call(c.body.children).map(function(b) {
        return xe(b, "mousemove", vt);
      })), function() {
        g(), v(), h(), x.forEach(function(b) {
          return b();
        });
      };
    }
  }, [e, o, f, l, u, m]);
}
var je = function(t) {
  var r;
  return typeof document > "u" ? null : t == null ? $t().body : (typeof t == "function" && (t = t()), t && "current" in t && (t = t.current), (r = t) != null && r.nodeType && t || null);
};
function gt(e, t) {
  var r = Ce(function() {
    return je(e);
  }), n = r[0], o = r[1];
  if (!n) {
    var i = je(e);
    i && o(i);
  }
  return J(function() {
    t && n && t(n);
  }, [t, n]), J(function() {
    var f = je(e);
    f !== n && o(f);
  }, [e, n]), n;
}
function ln(e) {
  var t = {};
  return Array.isArray(e) ? (e == null || e.forEach(function(r) {
    t[r.name] = r;
  }), t) : e || t;
}
function pn(e) {
  return e === void 0 && (e = {}), Array.isArray(e) ? e : Object.keys(e).map(function(t) {
    return e[t].name = t, e[t];
  });
}
function dn(e) {
  var t, r, n, o, i = e.enabled, f = e.enableEvents, a = e.placement, s = e.flip, l = e.offset, u = e.fixed, m = e.containerPadding, p = e.arrowElement, c = e.popperConfig, g = c === void 0 ? {} : c, v = ln(g.modifiers);
  return L({}, g, {
    placement: a,
    enabled: i,
    strategy: u ? "fixed" : g.strategy,
    modifiers: pn(L({}, v, {
      eventListeners: {
        enabled: f
      },
      preventOverflow: L({}, v.preventOverflow, {
        options: m ? L({
          padding: m
        }, (t = v.preventOverflow) == null ? void 0 : t.options) : (r = v.preventOverflow) == null ? void 0 : r.options
      }),
      offset: {
        options: L({
          offset: l
        }, (n = v.offset) == null ? void 0 : n.options)
      },
      arrow: L({}, v.arrow, {
        enabled: !!p,
        options: L({}, (o = v.arrow) == null ? void 0 : o.options, {
          element: p
        })
      }),
      flip: L({
        enabled: !!s
      }, v.flip)
    }))
  });
}
var qe = /* @__PURE__ */ et.forwardRef(function(e, t) {
  var r = e.flip, n = e.offset, o = e.placement, i = e.containerPadding, f = i === void 0 ? 5 : i, a = e.popperConfig, s = a === void 0 ? {} : a, l = e.transition, u = tt(), m = u[0], p = u[1], c = tt(), g = c[0], v = c[1], h = Ft(p, t), x = gt(e.container), b = gt(e.target), O = Ce(!e.show), d = O[0], w = O[1], y = Kr(b, m, dn({
    placement: o,
    enableEvents: !!e.show,
    containerPadding: f || 5,
    flip: r,
    offset: n,
    arrowElement: g,
    popperConfig: s
  })), E = y.styles, R = y.attributes, C = bt(y, ["styles", "attributes"]);
  e.show ? d && w(!1) : !e.transition && !d && w(!0);
  var P = function() {
    w(!0), e.onExited && e.onExited.apply(e, arguments);
  }, D = e.show || l && !d;
  if (cn(m, e.onHide, {
    disabled: !e.rootClose || e.rootCloseDisabled,
    clickTrigger: e.rootCloseEvent
  }), !D)
    return null;
  var M = e.children(L({}, C, {
    show: !!e.show,
    props: L({}, R.popper, {
      style: E.popper,
      ref: h
    }),
    arrowProps: L({}, R.arrow, {
      style: E.arrow,
      ref: v
    })
  }));
  if (l) {
    var $ = e.onExit, _ = e.onExiting, N = e.onEnter, j = e.onEntering, B = e.onEntered;
    M = /* @__PURE__ */ et.createElement(l, {
      in: e.show,
      appear: !0,
      onExit: $,
      onExiting: _,
      onExited: P,
      onEnter: N,
      onEntering: j,
      onEntered: B
    }, M);
  }
  return x ? /* @__PURE__ */ yt.createPortal(M, x) : null;
});
qe.displayName = "Overlay";
qe.propTypes = {
  /**
   * Set the visibility of the Overlay
   */
  show: A.bool,
  /** Specify where the overlay element is positioned in relation to the target element */
  placement: A.oneOf(ke),
  /**
   * A DOM Element, Ref to an element, or function that returns either. The `target` element is where
   * the overlay is positioned relative to.
   */
  target: A.any,
  /**
   * A DOM Element, Ref to an element, or function that returns either. The `container` will have the Portal children
   * appended to it.
   */
  container: A.any,
  /**
   * Enables the Popper.js `flip` modifier, allowing the Overlay to
   * automatically adjust it's placement in case of overlap with the viewport or toggle.
   * Refer to the [flip docs](https://popper.js.org/popper-documentation.html#modifiers..flip.enabled) for more info
   */
  flip: A.bool,
  /**
   * A render prop that returns an element to overlay and position. See
   * the [react-popper documentation](https://github.com/FezVrasta/react-popper#children) for more info.
   *
   * @type {Function ({
   *   show: boolean,
   *   placement: Placement,
   *   update: () => void,
   *   forceUpdate: () => void,
   *   props: {
   *     ref: (?HTMLElement) => void,
   *     style: { [string]: string | number },
   *     aria-labelledby: ?string
   *     [string]: string | number,
   *   },
   *   arrowProps: {
   *     ref: (?HTMLElement) => void,
   *     style: { [string]: string | number },
   *     [string]: string | number,
   *   },
   * }) => React.Element}
   */
  children: A.func.isRequired,
  /**
   * Control how much space there is between the edge of the boundary element and overlay.
   * A convenience shortcut to setting `popperConfig.modfiers.preventOverflow.padding`
   */
  containerPadding: A.number,
  /**
   * A set of popper options and props passed directly to react-popper's Popper component.
   */
  popperConfig: A.object,
  /**
   * Specify whether the overlay should trigger `onHide` when the user clicks outside the overlay
   */
  rootClose: A.bool,
  /**
   * Specify event for toggling overlay
   */
  rootCloseEvent: A.oneOf(["click", "mousedown"]),
  /**
   * Specify disabled for disable RootCloseWrapper
   */
  rootCloseDisabled: A.bool,
  /**
   * A Callback fired by the Overlay when it wishes to be hidden.
   *
   * __required__ when `rootClose` is `true`.
   *
   * @type func
   */
  onHide: function(t) {
    for (var r = arguments.length, n = new Array(r > 1 ? r - 1 : 0), o = 1; o < r; o++)
      n[o - 1] = arguments[o];
    if (t.rootClose) {
      var i;
      return (i = A.func).isRequired.apply(i, [t].concat(n));
    }
    return A.func.apply(A, [t].concat(n));
  },
  /**
   * A `react-transition-group@2.0.0` `<Transition/>` component
   * used to animate the overlay as it changes visibility.
   */
  // @ts-ignore
  transition: A.elementType,
  /**
   * Callback fired before the Overlay transitions in
   */
  onEnter: A.func,
  /**
   * Callback fired as the Overlay begins to transition in
   */
  onEntering: A.func,
  /**
   * Callback fired after the Overlay finishes transitioning in
   */
  onEntered: A.func,
  /**
   * Callback fired right before the Overlay transitions out
   */
  onExit: A.func,
  /**
   * Callback fired as the Overlay begins to transition out
   */
  onExiting: A.func,
  /**
   * Callback fired after the Overlay finishes transitioning out
   */
  onExited: A.func
};
const vn = qe, mn = (e) => {
  const { children: t, ...r } = e;
  return /* @__PURE__ */ Wt.jsx(vn, { ...r, children: ({ props: n, arrowProps: o, show: i, forceUpdate: f, update: a, ...s }) => t({
    ...s,
    ...n,
    show: i,
    arrowProps: o
  }) });
};
mn.propTypes = {
  show: A.bool,
  rootClose: A.bool,
  placement: A.oneOf(kt),
  children: A.func
};
export {
  mn as MotifTooltipOverlay
};
